export const compressImage = async (file, maxSizeMB = 1) => { // ✅ Réduit à 1MB au lieu de 2MB
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      const img = new Image();
      
      img.onload = () => {
        const canvas = document.createElement('canvas');
        let width = img.width;
        let height = img.height;
        
        // ✅ Dimensions plus petites
        const MAX_WIDTH = 1280;  // ✅ Au lieu de 1920
        const MAX_HEIGHT = 720;   // ✅ Au lieu de 1080
        
        if (width > height) {
          if (width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          }
        } else {
          if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }
        }
        
        canvas.width = width;
        canvas.height = height;
        
        const ctx = canvas.getContext('2d');
        ctx.drawImage(img, 0, 0, width, height);
        
        // ✅ Qualité encore plus basse
        canvas.toBlob(
          (blob) => {
            if (blob.size / 1024 / 1024 > maxSizeMB) {
              canvas.toBlob(
                (smallerBlob) => resolve(smallerBlob),
                'image/jpeg',
                0.5  // ✅ 50% au lieu de 60%
              );
            } else {
              resolve(blob);
            }
          },
          'image/jpeg',
          0.7  // ✅ 70% au lieu de 80%
        );
      };
      
      img.onerror = reject;
      img.src = e.target.result;
    };
    
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};
